import styled from 'styled-components';
import { LinearProgress } from '@mui/material';

import { PrimaryButton } from '../Button/ActionButtons';
import colors from '../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 45px;
`;

const Title = styled.div`
  font-size: 15px;
  font-weight: 600;
`;

const Description = styled.div`
  font-size: 13px;
  color: ${colors.shades.secondary2};
  margin-bottom: 4px;
`;

const StatusCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 8px;
  background-color: ${colors.shades.secondary10};
`;

const StatusRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const StyledLinearProgress = styled(LinearProgress)`
  height: 6px;
  border-radius: 3px;
`;

const HelperText = styled.div`
  font-size: 12px;
  color: ${colors.shades.secondary2};
  margin-top: 12px;
`;

const ErrorText = styled(HelperText)`
  color: ${colors.base.danger};
`;

/*
  The shared primary button rather than a bare MUI one: the theme's primary colour is lime, so an
  unstyled Button renders as lime text on white and is all but invisible.
*/
const SelectButton = styled(PrimaryButton)`
  align-self: flex-start;
  margin-top: 16px;
`;

/* The ready card is the one place the coach sees what they actually produced, rather than a label. */
const ReadyPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
`;

/*
  The same embedded Vimeo player the exercise editor uses, so a coach checks a session exactly the
  way they check an exercise clip. Sized by the video's own dimensions rather than a fixed 16:9,
  because coaches film sessions in portrait as often as landscape and a fixed box letterboxes one of
  the two badly.
*/
const SessionVideo = styled.iframe`
  width: 100%;
  max-width: 320px;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
  border: 0;
  border-radius: 4px;
  background-color: ${colors.shades.secondary7};
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
`;

const ReadyDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
  color: ${colors.shades.secondary2};
`;

export {
  Container,
  Title,
  Description,
  StatusCard,
  ReadyPreview,
  SessionVideo,
  ReadyDetails,
  StatusRow,
  StyledLinearProgress,
  HelperText,
  ErrorText,
  SelectButton,
  Actions,
};
